import React, { useContext, useEffect, useState } from 'react';
import BookerContext from '../../context/bookerContext';
import FetchService from '../../services/fetchService';
import urlService from '../../services/urlService';
import { ReactComponent as DefaultTips } from '../../assets/img/default-tips-icon.svg';
import { ReactComponent as PromoCode } from '../../assets/img/promo-code-icon.svg';
import { ReactComponent as BackBtn } from '../../assets/img/arrow.svg';
import { ReactComponent as AddCard } from '../../assets/img/add.svg';
import { updateCardInfo } from '../../utils/cardData';
import BookerShortContext from '../../context/bookerShortContext';
import { ReactComponent as StarIcon } from '../../assets/img/star.svg';
import '../../assets/styles/menu.sass';

const PaymentsMenu = ({ toggleMenu, setOpenPayments }) => {
  const context = useContext(BookerContext);
  const { toggleTips, updatePaymentsMenu, setUpdatePaymentsMenu } = useContext(BookerShortContext);
  const {
    state: { userProfile, defaultTips, step, editor, rideStatusRecordedFlags },
    updateDefaultTips,
    updateStep,
    updateEditor,
    updatePreviousStep,
    updateApplePayPaymentMethod,
    updatePayPalPaymentMethod,
  } = context;

  const [paymentPersonalMethods, setPaymentPersonalMethods] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const isApplePay = window.ApplePaySession;

  const loadUserPayments = () => {
    FetchService.getWebApiResource(urlService.loadPersonalPayments(userProfile.id))
      .then(response => {
        setIsLoading(false);
        if (response?.length && !isApplePay) {
          response = response.filter(item => item.type !== 'apple_pay');
        }
        if (!response.length) {
          if (paymentPersonalMethods.length) setPaymentPersonalMethods([]);
          return;
        }

        const isApplePayInArray = response?.filter(item => item.type === 'apple_pay')[0];
        const isPayPalInArray = response?.filter(item => item.type === 'paypal')[0];

        if (isApplePayInArray) updateApplePayPaymentMethod(isApplePayInArray.id);
        if (isPayPalInArray) updatePayPalPaymentMethod(isPayPalInArray.id);

        response.sort((a, b) => (a.id > b.id ? 1 : -1));
        if (!response?.find(item => item.default)) response[0].default = true;

        setPaymentPersonalMethods(updateCardInfo(response));
        console.log('Payments have been successfully loaded ', response);
      })
      .catch(error => {
        setIsLoading(false);
        console.log('Get payments with error ', error);
      })
      .finally(() => {
        setUpdatePaymentsMenu(false);
      });
  };

  useEffect(() => {
    loadUserPayments();
  }, []);

  useEffect(() => {
    if (!updatePaymentsMenu) return;

    setIsLoading(true);
    setTimeout(() => {
      loadUserPayments();
    }, 1000);
  }, [updatePaymentsMenu]);

  const tipsOpenHandler = () => {
    setIsLoading(true);
    FetchService.getWebApiResource(urlService.getProfile())
      .then(response => {
        const { user_profile: { default_tip = null, default_tip_type = '' } = {} } = response || {};
        updateDefaultTips({
          default_tip: default_tip_type === 'percent' ? default_tip * 100 : default_tip / 100,
          default_tip_type,
          default_selected: true,
        });
        toggleTips(true);
        setIsLoading(false);
      })
      .catch(() => {
        defaultTips.default_selected = true;
        updateDefaultTips(defaultTips);
        toggleTips(true);
        setIsLoading(false);
      });
  };

  const addPaymentOpenHandler = () => {
    const mediaQueryList = window.matchMedia('(max-width: 576px)');
    if (step !== 6 && step !== 16 && !editor?.isOpenedFromMenu) updatePreviousStep(step);
    updateStep(6);
    updateEditor({ key: 'payment', isOpenedFromMenu: true });
    if (mediaQueryList?.matches) toggleMenu();
  };

  const editPaymentOpenHandler = (e, item) => {
    const mediaQueryList = window.matchMedia('(max-width: 576px)');
    if (step !== 16 && step !== 6 && !editor?.isOpenedFromMenu) updatePreviousStep(step);
    updateStep(16);
    updateEditor({ key: 'payment', isOpenedFromMenu: true, payment: item });
    if (mediaQueryList?.matches) toggleMenu();
  };

  return (
    <div className="animated fadeIn clearfix sub-menu-info-dropdown">
      <div className="payment-sub-menu">
        <div className="menu-item-title-container">
          <div className="back-btn">
            <BackBtn onClick={() => setOpenPayments(false)} />
          </div>
          <div className="menu-item-title">Payments</div>
        </div>
        {!!paymentPersonalMethods.length && (
          <ul className="dropdown-list clearfix">
            {paymentPersonalMethods.map(item => (
              <li
                key={item.id}
                className={`payment-list-item${rideStatusRecordedFlags?.isRideActive ? ' disabled' : ''}`}
                {...(!rideStatusRecordedFlags?.isRideActive && { onClick: e => editPaymentOpenHandler(e, item) })}
              >
                <span className="card-icon">
                  <i className={item.icon} aria-hidden="true" />
                </span>
                <span className="card-label">{item.fullName}</span>
                {item.default && (
                  <span className="default-card">
                    <StarIcon />
                  </span>
                )}
              </li>
            ))}
          </ul>
        )}
        <ul className="dropdown-list clearfix">
          <li className="dropdown-item" onClick={addPaymentOpenHandler}>
            <AddCard />
            <div className="dropdown-item-value">Add Payment Method</div>
          </li>
        </ul>
      </div>

      <ul className="dropdown-list clearfix">
        <li className="dropdown-item" onClick={tipsOpenHandler}>
          <DefaultTips />
          <div className="dropdown-item-value">My Default Tip</div>
        </li>
        <li className="dropdown-item disabled">
          <PromoCode />
          <div className="dropdown-item-value">Enter Promo Code</div>
        </li>
      </ul>

      {isLoading && (
        <div className="loading-container">
          <div className="spin" />
        </div>
      )}
    </div>
  );
};

export default PaymentsMenu;
